import {
    OFFER_SUMMARY_CARD_HEADLINE_CLASSNAME,
    OfferSummaryCard,
    createOfferSummaryCard,
} from '@vfde-brix/ws10/offer-summary-card';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';
import { JarvisHomebox } from '../interface';
import { getOfferSummaryCardButtonProps } from '../util/components/buttonHelper';
import { getOfferSummaryCardHeadlineProps } from '../util/components/headlineHelper';
import {
    getAdditionalPrices,
    getPriceProps,
    getSublineTexts,
} from '../util/components/offerSummaryCardHelper';

/**
 * Create Offer Price component.
 * @param {HtmlId} id - Wrapper ID of the element.
 * @returns {OfferSummaryCard|null} OfferSummaryCard component or null if element with given id is not found.
 */
export const mountOfferSummaryCard = (id: HtmlId) =>
    createComponentById(createOfferSummaryCard, id, NO_PATTERN_BUSINESS_LOGIC);

/**
 * Append a metacode to the "data-metacode" attribute of the given html element.
 * @param {Element} offerSummaryCardEl - Container element of the Offer Price Brix component.
 * @param {string} metacode - Metacode to display.
 */
const updateDisplayMetacodes = (offerSummaryCardEl: Element, metacode: string) => {
    const [ headlineEl ] = offerSummaryCardEl?.
        getElementsByClassName(OFFER_SUMMARY_CARD_HEADLINE_CLASSNAME) || [];

    headlineEl && headlineEl.setAttribute('data-metacode', metacode);
};

/**
 * Update every Offer Price related components.
 * @param {OfferSummaryCard|null} offerSummaryCard - OfferSummaryCard component or null.
 * @param {JarvisHomebox} router - Selected router product.
 * @param {boolean} isLoggedIn - Login status.
 * @param {boolean} isContentEnabled - Whether routers are available or not.
 */
export const updateOfferSummaryCard = (
    offerSummaryCard: OfferSummaryCard | null,
    router: JarvisHomebox,
    isLoggedIn: boolean,
    isContentEnabled: boolean,
) => {
    if (!offerSummaryCard) {
        return;
    }

    const offerSummaryCardEl = offerSummaryCard.getContainerElement();

    offerSummaryCard.updateHeadline(getOfferSummaryCardHeadlineProps(router.name, isContentEnabled));
    offerSummaryCard.updateSubline(getSublineTexts(isContentEnabled));
    offerSummaryCard.updatePrices(
        getPriceProps(router.price, isContentEnabled),
        getAdditionalPrices(router, isContentEnabled)
    );
    offerSummaryCard.updateButtons(
        [getOfferSummaryCardButtonProps(router.id, isLoggedIn, isContentEnabled)]
    );

    updateDisplayMetacodes(offerSummaryCardEl, router.id);
};
